if (process.env.NODE_ENV !== 'production') {
  const { PolyfillChecker, createReactAppPreset } = require('polyfill-checker')
  const checker = new PolyfillChecker({
    minBrowsers: {
      ie: '11',
      edge_mobile: '12',
      webview_android: '38',
    },
    exclude: [createReactAppPreset],
  })
  checker.downgradeMode()
  // checker.injectChecker()
}

var values = require('object.values')
var padStart = require('string.prototype.padstart')

if (!Object.values) {
  values.shim()
}
if (!String.prototype.padStart) {
  padStart.shim()
}
if (!Array.prototype.find) {
  require('core-js/fn/array/find')
}
if (!String.prototype.endsWith) {
  require('core-js/fn/string/ends-with')
}



// WEBPACK FOOTER //
// ./src/polyfills.js